import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAppointment } from "../api/bookingApi";
import { BarbershopContext } from "../providers/useProvider";

const useAppointmentSummary = () => {
  const { bookingId } = useParams(); // from route /:bookingId/appointment-summary
  const navigate = useNavigate();
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const { config } = useContext(BarbershopContext);

  useEffect(() => {
    const fetchAppointment = async () => {
      try {
        const response = await getAppointment(bookingId, config.id);
        setAppointment(response);
      } catch (error) {
        console.error("Failed to fetch appointment:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointment();
  }, [bookingId]);

  const onBackClick = () => {
    setAppointment(null);
    setLoading(false);
    navigate(`/`);
  };
  return { appointment, loading, onBackClick };
};
export default useAppointmentSummary;
